import { render, staticRenderFns } from "./forgetWord.vue?vue&type=template&id=3d9d6088&scoped=true"
import script from "./forgetWord.vue?vue&type=script&lang=js"
export * from "./forgetWord.vue?vue&type=script&lang=js"
import style0 from "./forgetWord.vue?vue&type=style&index=0&id=3d9d6088&prod&scoped=true&lang=scss&ref=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9d6088",
  null
  
)

export default component.exports